import dayjs from 'dayjs'
import TokTokDocDataTable from '../../Common/DataTable'
import PatientHistoryDownloadDocument from './PatientHistoryDownloadDocument'
import { PatientHistoryDownloadMedias } from './PatientHistoryDownloadMedias'
import useTTDFlag from '../../../hooks/useTTDFlag'
import { TConsultationForPatientIds } from '@toktokdoctech/tokapi-client'
import { getTCHeaders } from './_utils'
import { PatientConsultationHistoryProps } from './_props'

const PatientConsultationHistory = ({
    data,
    patient,
    isLoading,
    isError,
    page,
    itemsPerPage,
    handlePaginationChange,
    handleItemsPerPageChange,
}: PatientConsultationHistoryProps) => {
    const isMinioEnabled = useTTDFlag('minio')

    if (isError) {
        return null
    }

    const describeRows = (row: TConsultationForPatientIds) => {
        const appointmentDateShort = row.appointmentDate
            ? dayjs(new Date(row.appointmentDate)).format('DD_MM_YYYY')
            : ''

        const result = [
            {
                item: row.appointmentDate ? dayjs(new Date(row.appointmentDate)).format('DD/MM/YYYY - HH:mm') : '',
            },
            {
                item: row.requiredExpert?.fullName,
            },
            {
                item: row.requiredExpert?.speciality ?? row.requiredExpert?.profession,
            },
            {
                item: isMinioEnabled && (row.pictures.length > 0 || row.documents.length > 0) && (
                    <PatientHistoryDownloadMedias actType="CONSULTATION" item={row} type="medias" />
                ),
            },
            {
                item: row.invoice && row.invoice.downloadUrl && !row.invoice.isForHcs && (
                    <div>
                        {row.invoice && (
                            <PatientHistoryDownloadDocument
                                item={{
                                    downloadUrl: row.invoice.downloadUrl,
                                }}
                                type="invoice"
                                fileName={`${patient.fullName}_${appointmentDateShort}_FACTURATION`}
                            />
                        )}
                        {row.careDocument && row.careDocument.downloadUrl && !row.careDocument.isForRequiredExpert && (
                            <PatientHistoryDownloadDocument
                                item={{
                                    downloadUrl: row.careDocument.downloadUrl,
                                }}
                                type="careDocument"
                                fileName={`${patient.fullName}_${appointmentDateShort}_FSE`}
                            />
                        )}
                    </div>
                ),
            },
            {
                item: row.prescription && (
                    <PatientHistoryDownloadDocument
                        item={{
                            downloadUrl: row.prescription.downloadUrl ?? '',
                        }}
                        type="prescription"
                        fileName={`${patient.fullName}_${appointmentDateShort}_PRESCRIPTION`}
                    />
                ),
            },
            {
                item: row.summary && (
                    <PatientHistoryDownloadDocument
                        item={{
                            downloadUrl: row.summary.downloadUrl ?? '',
                        }}
                        type="summary"
                        fileName={`${patient.fullName}_${appointmentDateShort}_CR`}
                    />
                ),
            },
        ]

        if (!isMinioEnabled) result.splice(3, 1)
        return result
    }

    return (
        <TokTokDocDataTable
            loading={isLoading}
            page={page}
            itemsPerPage={itemsPerPage}
            count={data?.total}
            handlePaginationChange={handlePaginationChange}
            handleItemsPerPageChange={handleItemsPerPageChange}
            headers={getTCHeaders(isMinioEnabled)}
            items={data?.items ?? []}
            describeRows={describeRows}
        />
    )
}

export default PatientConsultationHistory
